<template>
  <v-sheet class="py-2 px-5">
  </v-sheet>
</template>

<script>

export default {
  name: "PlannedServicesReport",

  data() {
    return {
      enableFetch: false,
    };
  },

  methods: {
    fetchReport() {
      if (this.enableFetch && this.period !== null)
        this.$store.dispatch("report/fetch", {
          name: "planned-services",
          groupset: this.$store.getters["groupsets/getGroupsetId"],
          output: "pdf",
          download: false
        })
          .then(response => {
            this.$emit("pdf", response.data);
          });
    },

    downloadReport(output) {
      if (this.period !== null)
        this.$store.dispatch("report/fetch", {
          name: "planned-services",
          groupset: this.$store.getters["groupsets/getGroupsetId"],
          output: output,
          download: true
        });
    },

    updateUrl() {
      this.$router.replace({
        name: "report/planned-services", query: {
          ...this.$route.query
        }
      }).catch(() => {
      });
    }
  },

  watch: {
    "$store.state.groupsets.groupset": function() {
      this.fetchReport();
    }
  },

  mounted() {
    this.$emit("report",
      {
        name: "planned-services",
        download: this.downloadReport
      }
    );

    setTimeout(() => {
      this.enableFetch = true;
      this.fetchReport();
    }, 1);
  }
};
</script>

<style scoped>

</style>